import {ChartFrame, IChartStop, IVypuskChart} from '@containers/monitoringPlatform/passengerCharts/types'

export interface ISegment {
	key: string
	fromStop: string
	toStop: string
	from: number
	to: number
	frames: ChartFrame[]
	avg: number | null
	estimated: boolean
	deviceId: number | null
	licencePlate: string | null
	cameraIds: string[]
}

const NEAREST_FRAME_SECONDS = 90

const cleanName = (name: string | null) => (name ?? '—').replace(/\s*\([^)]*\)$/, '')

export const circlesOf = (vypusk: IVypuskChart): number[] =>
	Array.from(new Set(vypusk.stops.filter((s) => s.realArrival != null).map((s) => s.circle))).sort((a, b) => a - b)

export const buildSegments = (vypusk: IVypuskChart, circle: number): ISegment[] => {
	const passed = vypusk.stops
		.filter((s): s is IChartStop & {realArrival: number} => s.circle === circle && s.realArrival != null)
		.sort((a, b) => a.realArrival - b.realArrival)

	return passed.slice(1).map((next, i) => {
		const prev = passed[i]
		const from = prev.realDeparture ?? prev.realArrival
		const to = next.realArrival
		const inside = vypusk.frames.filter(([t]) => t >= from && t <= to)
		const middle = (from + to) / 2
		const nearest = inside.length ? null : vypusk.frames
			.filter(([t]) => Math.abs(t - middle) <= NEAREST_FRAME_SECONDS)
			.sort((a, b) => Math.abs(a[0] - middle) - Math.abs(b[0] - middle))[0]
		const frames = inside.length ? inside : nearest ? [nearest] : []
		const vehicle = vypusk.vehicles.find((v) => from >= v.from && from <= v.to) ?? null
		return {
			key: `${circle}-${prev.ordinal}-${next.ordinal}`,
			fromStop: cleanName(prev.name),
			toStop: cleanName(next.name),
			from,
			to,
			frames,
			avg: frames.length ? Math.round(frames.reduce((sum, [, v]) => sum + v, 0) / frames.length) : null,
			estimated: !inside.length && !!nearest,
			deviceId: vehicle?.deviceId ?? null,
			licencePlate: vehicle?.licencePlate ?? null,
			cameraIds: vehicle?.cameraIds ?? [],
		}
	})
}
